import { CONTACT_PERSON_TYPES } from "@constants/contactPerson";
import apiCall from "@services//apiConfig/apiCall.config";
import API_URL from "@services/apiConfig/api.config";

export async function getContactPerson(id: string, type: CONTACT_PERSON_TYPES) {
  return await apiCall.get(
    `${API_URL.CONTACT_PERSON.GET_CONTACT_PERSON}${type}/${id}`,
    {}
  );
}
